import { render, staticRenderFns } from "./step2Mapping.vue?vue&type=template&id=5f4f66ce&scoped=true&"
import script from "./step2Mapping.vue?vue&type=script&lang=js&"
export * from "./step2Mapping.vue?vue&type=script&lang=js&"
import style0 from "./step2Mapping.vue?vue&type=style&index=0&id=5f4f66ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f66ce",
  null
  
)

export default component.exports